import React from 'react';
import { Typography, Tooltip } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';

interface IData {
  value: number;
  label: string;
  color: string;
}

interface ISingleBarChartProps {
  title?: string;
  data: IData[];
}

const SingleBarChart: React.FC<ISingleBarChartProps> = ({ title, data }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const total = data.map(item => item.value).reduce((a, b) => a + b);

  return (
    <div className={classes.container}>
      {title && (
        <Typography variant="h3" className={classes.title}>
          {title}
        </Typography>
      )}
      <div className={classes.barContainer}>
        {data.map((item, index) => (
          <div key={index} style={{ width: `${(item.value / total) * 100}%` }}>
            <Tooltip
              arrow
              placement="top"
              title={`${item.label}: ${item.value}`}
              arial-label={`${item.label}`}
            >
              <div
                style={{ backgroundColor: item.color }}
                className={clsx(classes.bar, {
                  [classes.firstBar]: index === 0,
                  [classes.lastBar]: index + 1 === data.length,
                })}
              />
            </Tooltip>
            {item.value !== 0 && item.value / total > 0.2 && (
              <Typography variant="subtitle1" className={classes.subtitle}>
                {item.label}
              </Typography>
            )}
          </div>
        ))}
        {total === 0 && (
          <Typography variant="h3" className={classes.noDataMessage}>
            {t('components:charts.noData')}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default SingleBarChart;
